import React, { Component, Fragment } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import { Link } from 'react-router-dom';

import Footer from '../../../components/Footer';

import './style.scss';
import { chunk } from '../../../utils/array';

const brands = {
    fashion: [
        { name: 'jd', label: 'JD' },
        { name: 'size', label: 'Size?' },
        { name: 'footpatrol', label: 'Footpatrol' },
        { name: 'finishline', label: 'Finish Line' },
        { name: 'shoepalace', label: 'Shoe Palace' },
        { name: 'dtlr', label: 'DTLR' },
        { name: 'livestock', label: 'Livestock' },
        { name: 'sprinter', label: 'Sprinter' },
        { name: 'sportzone', label: 'Sportzone' },
        { name: 'sur', label: 'Sports Unlimited Retail' },
        { name: 'chausport', label: 'Chausport' },
        { name: 'sizeer', label: 'Sizeer' },
        { name: 'jdgyms', label: 'JD Gyms' },
        { name: 'tessuti', label: 'Tessuti' },
        { name: 'scotts', label: 'Scotts' },
        { name: 'mainline', label: 'Mainline' },
    ],
    outdoors: [
        { name: 'blacks', label: 'Blacks' },
        { name: 'millets', label: 'Millets' },
        { name: 'tiso', label: 'Tiso' },
        { name: 'gooutdoors', label: 'GO Outdoors' },
        { name: 'ultimateoutdoors', label: 'Ultimate Outdoors' },
        { name: 'fishingrepublic', label: 'Fishing Republic' },
        { name: 'naylors', label: 'Naylors' },
    ],
};

export default class Group extends Component {
    render() {
        const { shortname } = this.props;
        return (
            <ReactFullpage
                scrollBar
                licenseKey={'509941D1-3F034827-933D440A-25570100'}
                verticalCentered
                responsiveWidth={'951'}
                render={comp => {
                    return (
                        <ReactFullpage.Wrapper>
                            <div className="section fp-auto-height group-section">
                                <div className="navgap"></div>
                                <ul className="toggle">
                                    <Link to="/our-group" title="Sports Fashion">
                                        <li className={shortname ? null : 'selected'}>Sports Fashion</li>
                                    </Link>
                                    <Link to="/our-group/outdoors" title="Outdoor Fashion">
                                        <li className={shortname === 'outdoors' ? 'selected' : null}>Outdoor</li>
                                    </Link>
                                </ul>
                            </div>
                            {shortname === 'outdoors' ? (
                                <Fragment>
                                    <div className="section fp-auto-height group-section">
                                        <ul className="grid">
                                            {brands.outdoors.map(brand => (
                                                <li className={brand.name}>
                                                    <Link title={brand.label} to={`/our-group/${brand.name}`}>
                                                        <div>
                                                            <i />
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="scroll">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    {chunk(brands.fashion, 4).map((list, index, all) => (
                                        <div className="section fp-auto-height group-section">
                                            <ul className="grid">
                                                {list.map(brand => (
                                                    <li className={brand.name}>
                                                        <Link title={brand.label} to={`/our-group/${brand.name}`}>
                                                            <div>
                                                                <i />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                            {index < all.length - 2 && (
                                                <div className="scroll">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </Fragment>
                            )}
                            <div className="footer section fp-auto-height">
                                <Footer />
                            </div>
                        </ReactFullpage.Wrapper>
                    );
                }}
            />
        );
    }
}
